module.exports = __webpack_public_path__ + "img/2345_18.0a9f6dc4.jpeg";